import { config } from 'application';

export function asset(url: string): string {
  return config.publicUrl + url;
}

export function getCountryFlag(codeIso3: string) {
  return `https://partnersportprodcdn.blob.core.windows.net/flags/${codeIso3}.jpg`;
}
